function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.822,
  height: 21.213,
  transform: "translate(3.465)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1.822,
  height: 21.213,
  transform: "translate(0 0.011)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 1.822,
  height: 21.213,
  transform: "translate(6.862)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 1.822,
  height: 21.213,
  transform: "translate(10.19)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 1.822,
  height: 21.213,
  transform: "translate(13.61)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 3.412,
  height: 1.674,
  transform: "translate(17.176 0.881)"
});

function SvgHeizkoerper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.589,
    height: 21.224,
    viewBox: "0 0 20.589 21.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeizkoerper);
export default __webpack_public_path__ + "static/media/heizkoerper.9ce339881726d1c8bec4ef4585973852.svg";
export { ForwardRef as ReactComponent };